<template>
  <div v-if="MeetingVisible" class="alert alert-warning text-center">
    Sevgili Öğrencimiz, dersiniz başlamak üzeredir. Öğretmeninizle olan derse katılmak için <a v-bind:href="MeetingUrl" class="text-dark" target="_blank"><strong>tıklaynız</strong></a>.
  </div>
</template>
  <script>
 import store from "@/store";
  export default {
    name: "NotificationForMeeting",
    data(){
      return{
      }
    },
    components: {
    },
    computed: {
      MeetingUrl(){
        return store.getters['MeetingUrl'];
      },
      MeetingVisible(){
          if(this.MeetingUrl!=''){
            return true;
          }
          return false;
      }
      
    },
    methods: {
      async Init(){
        if(!window.globalTimer){
          window.globalTimer = setInterval(function(){
            this.$store.dispatch("AddMeetingUrl");
          }.bind(this),15000);
        }
      }
    },
    mounted: function() {
      this.Init();
    }
  };
  </script>
  
  <style>
    
  </style>